const apiConfig = "04a4e289560df780daea612e3d6043d9";
export {apiConfig};